import { frontendURL } from '../../../helper/URLHelper';
import UsersIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ardhisasa/users'),
    name: 'ardhisasa_users',
    component: UsersIndex,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
